import React from 'react'
import classnames from 'classnames'
import { CustomTemplateSchedule } from '../../../core/pre-making'
import tableStyles from '../../styles/modules/table.module.scss'
import styles from '../../styles/modules/pre-making/custom-template-schedule-table.module.scss'
import moment from 'moment'

interface Props {
  schedules: CustomTemplateSchedule[]
  isLoading: boolean
}

const CustomTemplateScheduleTable: React.FC<Props> = ({
  schedules,
  isLoading,
}) => {
  if (isLoading && schedules.length === 0) {
    return (
      <div className={styles.templateSection}>
        <h3 className={tableStyles.title}>カスタムテンプレート適用日一覧</h3>
        <div className={styles.loadingMessage}>読み込み中...</div>
      </div>
    )
  }

  if (schedules.length === 0) {
    return (
      <div className={styles.templateSection}>
        <h3 className={tableStyles.title}>カスタムテンプレート適用日一覧</h3>
        <div className={styles.noSchedules}>
          適用日が設定されたカスタムテンプレートがありません
        </div>
      </div>
    )
  }

  // 日付昇順でソート
  const sortedSchedules = [...schedules].sort(
    (a, b) =>
      new Date(a.selectedDate).getTime() - new Date(b.selectedDate).getTime()
  )

  return (
    <div className={styles.templateSection}>
      <h3 className={tableStyles.title}>カスタムテンプレート適用日一覧</h3>
      <div
        className={classnames({
          [tableStyles.wrapper]: true,
          [tableStyles.stocker]: true,
        })}
      >
        <table
          className={`${tableStyles.container} ${tableStyles.customTemplateScheduleTable}`}
        >
          <tbody>
            <tr className={tableStyles.row}>
              <th className={tableStyles.cell}>適用日</th>
              <th className={tableStyles.cell}>テンプレート名</th>
            </tr>
            {sortedSchedules.map(schedule => (
              <tr
                key={`${schedule.templateId}-${schedule.selectedDate}`}
                className={tableStyles.row}
              >
                <td className={tableStyles.cell}>
                  {moment(schedule.selectedDate).format('YYYY年MM月DD日')}
                </td>
                <td className={tableStyles.cell}>{schedule.templateName}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default CustomTemplateScheduleTable
